var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloorball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430.332,
    height: 430.256,
    viewBox: "0 0 430.332 430.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14718",
    "data-name": "Group 14718",
    transform: "translate(-12220.081 3506.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M139.4,69.3c-80.572,80.556-80.572,211.365,0,291.921s211.408,80.556,291.979,0,80.573-211.365,0-291.921C350.479-11.578,219.971-11.578,139.4,69.3Zm25.636,312.889L118.091,335.26a33.191,33.191,0,1,1,46.943,46.934ZM318.517,328.27a33.293,33.293,0,1,1-33.293-33.286A33.388,33.388,0,0,1,318.517,328.27ZM205.321,215.1a33.293,33.293,0,1,1-33.293-33.286A33.388,33.388,0,0,1,205.321,215.1ZM405.412,382.19a33.191,33.191,0,0,1,46.943-46.934ZM308.86,238.729a33.191,33.191,0,1,1,0-46.934C321.843,204.444,321.843,225.747,308.86,238.729ZM165.035,94.933a33.161,33.161,0,0,1-46.943,0L165.035,48A33.145,33.145,0,0,1,165.035,94.933ZM431.712,215.1a33.293,33.293,0,1,1-33.294-33.286A33.389,33.389,0,0,1,431.712,215.1Zm-113.2-113.172a33.293,33.293,0,1,1-33.293-33.286A33.388,33.388,0,0,1,318.517,101.925Zm86.9-6.99a33.146,33.146,0,0,1,0-46.934l46.943,46.934A33.161,33.161,0,0,1,405.412,94.935Z",
    transform: "translate(12150.023 -3506.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M412.832,206.378c0,113.981-92.414,206.378-206.416,206.378S0,320.359,0,206.378,92.414,0,206.416,0,412.832,92.4,412.832,206.378",
    transform: "translate(12228.831 -3498.168)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 17.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorball);
export default __webpack_public_path__ + "static/media/Floorball.79ca1081e28c31fc72afc595e4419733.svg";
export { ForwardRef as ReactComponent };